
export const sortOrderOptions = Object.freeze({
    None: 'None',
    Ascending: 'Ascending',
    Descending: 'Descending'
});
